import React, { useState, useEffect, useCallback } from 'react';
import { showToast } from '../utils/toast';
import { FiEdit2, FiPlus, FiToggleLeft, FiToggleRight, FiTrash2 } from 'react-icons/fi';
import api from '../services/api';
import '../styles/Configuracion.css';

export default function FamiliaProductosPage() {
  const [rows,      setRows]      = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState('');
  const [modal,     setModal]     = useState(null);
  const [form,      setForm]      = useState({ nombre: '', descripcion: '' });
  const [saving,    setSaving]    = useState(false);
  const [modalError, setModalError] = useState('');

  const load = useCallback(async () => {
    setLoading(true); setError('');
    try {
      const r = await api.get('/api/config/familias');
      setRows(r.data.data || []);
    } catch (e) { setError(e.response?.data?.error || e.message); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  const openNew  = () => { setForm({ nombre: '', descripcion: '' }); setModalError(''); setModal({ mode: 'new' }); };
  const openEdit = (r) => { setForm({ nombre: r.nombre, descripcion: r.descripcion || '' }); setModalError(''); setModal({ mode: 'edit', id: r.id }); };

  const handleSave = async () => {
    if (!form.nombre.trim()) { setModalError('El nombre es requerido'); return; }
    setSaving(true); setModalError('');
    try {
      if (modal.mode === 'new') await api.post('/api/config/familias', form);
      else await api.put(`/api/config/familias/${modal.id}`, form);
      await load(); setModal(null);
    } catch (e) {
      const msg = e.response?.data?.error || e.message;
      setModalError(msg.includes('Duplicate') ? 'Ya existe una familia con ese nombre.' : msg);
    } finally { setSaving(false); }
  };

  const handleToggle = async (id) => {
    try { await api.patch(`/api/config/familias/${id}/activo`); await load(); }
    catch (e) { showToast(e.response?.data?.error || 'Error'); }
  };

  const handleDelete = async (r) => {
    if (!window.confirm(`¿Eliminar la familia "${r.nombre}"?`)) return;
    try { await api.delete(`/api/config/familias/${r.id}`); await load(); }
    catch (e) { showToast(e.response?.data?.error || 'Error al eliminar'); }
  };

  return (
    <div className="cfg-page">
      <div className="cfg-toolbar">
        <button className="cfg-btn-nuevo" onClick={openNew}><FiPlus /> Nueva Familia</button>
      </div>

      {loading ? <div className="cfg-loading">Cargando...</div>
       : error  ? <div className="cfg-error">{error}</div>
       : (
        <table className="cfg-table">
          <thead>
            <tr>
              <th className="cfg-th">Familia / Categoría</th>
              <th className="cfg-th">Descripción</th>
              <th className="cfg-th">Estado</th>
              <th className="cfg-th cfg-th-action"></th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0
              ? <tr><td colSpan={4} className="cfg-empty">Sin familias registradas</td></tr>
              : rows.map((r, i) => (
                <tr key={r.id} className={i % 2 === 0 ? 'cfg-row-even' : 'cfg-row-odd'}>
                  <td className="cfg-td" style={{ fontWeight: 600 }}>{r.nombre}</td>
                  <td className="cfg-td">{r.descripcion || '—'}</td>
                  <td className="cfg-td">
                    <span style={{
                      display: 'inline-block', padding: '2px 10px', borderRadius: 12,
                      fontSize: 11, fontWeight: 700,
                      color: r.activo ? '#16a34a' : '#dc2626',
                      background: (r.activo ? '#16a34a' : '#dc2626') + '12',
                      border: `1px solid ${(r.activo ? '#16a34a' : '#dc2626')}44`,
                    }}>
                      {r.activo ? 'ACTIVO' : 'INACTIVO'}
                    </span>
                  </td>
                  <td className="cfg-td cfg-td-action">
                    <div className="ia-actions">
                      <button className="ia-btn ia-btn--edit" onClick={() => openEdit(r)} title="Editar"><FiEdit2 size={15} /></button>
                      <button
                        className={`ia-btn ${r.activo ? 'ia-btn--on' : 'ia-btn--off'}`}
                        onClick={() => handleToggle(r.id)}
                        title={r.activo ? 'Desactivar' : 'Activar'}
                      >
                        {r.activo ? <FiToggleLeft size={15} /> : <FiToggleRight size={15} />}
                      </button>
                      <button className="ia-btn ia-btn--danger" onClick={() => handleDelete(r)} title="Eliminar">
                        <FiTrash2 size={15} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
      )}

      <div className="cfg-footer">
        Todos los Derechos reservados Devel@per F@xy &nbsp;·&nbsp; www.developerfoxy.com
      </div>

      {modal && (
        <div className="cfg-modal-overlay">
          <div className="cfg-modal" onClick={e => e.stopPropagation()}>
            <div className="cfg-modal-header">
              <span>{modal.mode === 'new' ? 'Nueva Familia' : 'Editar Familia'}</span>
              <button className="cfg-modal-close" onClick={() => setModal(null)}>×</button>
            </div>
            <div className="cfg-modal-body">
              <div className="cfg-field-row">
                <label className="cfg-field-label">Nombre *</label>
                <input className="cfg-input" value={form.nombre}
                  onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))}
                  placeholder="Ej: FERRETERÍA, LUBRICANTES, PINTURAS..." autoFocus />
              </div>
              <div className="cfg-field-row">
                <label className="cfg-field-label">Descripción</label>
                <input className="cfg-input" value={form.descripcion}
                  onChange={e => setForm(p => ({ ...p, descripcion: e.target.value }))}
                  placeholder="Descripción opcional" />
              </div>
            </div>
            {modalError && <div className="cfg-modal-error">{modalError}</div>}
            <div className="cfg-modal-footer">
              <button className="cfg-btn-save" onClick={handleSave} disabled={saving}>
                {saving ? 'Guardando...' : modal.mode === 'new' ? 'Guardar' : 'Modificar'}
              </button>
              <button className="cfg-btn-cancel" onClick={() => setModal(null)}>× Salir</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
